import React from 'react'

export default () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M19.7071 6.08579C20.0976 6.47631 20.0976 7.10948 19.7071 7.5L9 18.2071L4.29289 13.5C3.90237 13.1095 3.90237 12.4763 4.29289 12.0858C4.68342 11.6953 5.31658 11.6953 5.70711 12.0858L9 15.3787L18.2929 6.08579C18.6834 5.69526 19.3166 5.69526 19.7071 6.08579Z" fill="#194074"/>
  </svg>
)
